export default __webpack_public_path__ + "static/media/MDR-Block-logo-h-Blue.27ac8935.svg";